/* 6LYETS core runtime. Real Shopify cart, flavour accent switching, scroll reveal.
   Dependency-free so no app embed can break it. */
(function () {
  if (window.SIXL) return;
  var SIXL = (window.SIXL = {});

  var toastEl, toastTimer;
  function toast(msg, withCartLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.id = 'sixl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span class="tick">&#10003;</span><span>' + msg + '</span>' +
      (withCartLink ? '<a href="/cart">View cart</a>' : '');
    requestAnimationFrame(function () { toastEl.classList.add('is-open'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 4000);
  }
  SIXL.toast = toast;

  function paintCount(count) {
    document.querySelectorAll('[data-sixl-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 320);
    });
  }

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) paintCount(cart.item_count); return cart; })
      .catch(function () { return null; });
  }
  SIXL.refreshCount = refreshCount;

  function addToCart(variantId, qty, label, button) {
    if (!variantId) { toast('That flavour is unavailable right now.'); return; }
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (!r.ok) { toast(r.data.description || 'Could not add that to your cart.'); return; }
        return refreshCount().then(function (cart) {
          toast((label || 'Added') + ' \u2014 added to cart', true);
          document.dispatchEvent(new CustomEvent('sixl:cart:added', { detail: { cart: cart } }));
        });
      })
      .catch(function () { toast('Network trouble. Please try again.'); })
      .then(function () { if (button) button.removeAttribute('aria-busy'); });
  }
  SIXL.addToCart = addToCart;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sixl-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.dataset.sixlAdd, Number(btn.dataset.sixlQty || 1), btn.dataset.sixlLabel, btn);
  });

  function observeReveals(root) {
    var nodes = (root || document).querySelectorAll('.sixl-reveal:not([data-observed])');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    nodes.forEach(function (n) { n.dataset.observed = '1'; io.observe(n); });
  }
  SIXL.observeReveals = observeReveals;

  function boot() { observeReveals(); refreshCount(); }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  document.addEventListener('shopify:section:load', function (e) { observeReveals(e.target); });
})();
